/*
 * ves-reveal.js: one shared IntersectionObserver that drives every scroll
 * reveal on the site. Elements opt in with `data-ves-reveal-on-scroll` (the
 * whole element rises + fades) or `data-ves-reveal-children` (its direct
 * children cascade, staggered by position). When an element scrolls into view
 * the observer adds `.ves-in` and stops watching it. All the motion lives in
 * CSS (translate + opacity only); this file just flips the class.
 *
 * Cost: one observer for the whole page, no scroll listeners, ~1 KB. The hidden
 * state is gated in CSS behind `(prefers-reduced-motion: no-preference) and
 * (scripting: enabled)`, so content is always visible if motion is reduced, JS
 * is off, or the browser is old; this script only ever reveals, never hides.
 */
(function () {
  var SELECTOR = '[data-ves-reveal-on-scroll], [data-ves-reveal-children]';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function reveal(el) {
    el.classList.add('ves-in');
  }

  function ensureObserver() {
    if (io || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        // Reveal when in view, or when the element is already scrolled past (its
        // bottom is at/above the top edge) so a deep-link jump to a mid-page
        // anchor never leaves the sections above it stuck hidden.
        if (e.isIntersecting || e.boundingClientRect.bottom <= 0) {
          reveal(e.target);
          obs.unobserve(e.target);
        }
      }
    }, {
      // Trigger a hair before the element is fully on screen so the entrance
      // reads as the section "arriving", not popping in after it's already there.
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08
    });
    return io;
  }

  function init() {
    var nodes = document.querySelectorAll(SELECTOR);
    if (!nodes.length) return;
    // Reduced motion: CSS keeps everything visible; nothing to do.
    if (reduce) return;
    // No IntersectionObserver (very old browser): reveal everything now.
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) reveal(nodes[i]);
      return;
    }
    var obs = ensureObserver();
    for (var j = 0; j < nodes.length; j++) {
      var n = nodes[j];
      if (n.dataset.vesRevealBound === '1') continue;
      n.dataset.vesRevealBound = '1';
      obs.observe(n);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-scan when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
